import { render, staticRenderFns } from "./KeyAddManagersDialog.vue?vue&type=template&id=0b66a003&"
import script from "./KeyAddManagersDialog.vue?vue&type=script&lang=ts&"
export * from "./KeyAddManagersDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports